import NestedSet from 'nested-set';

export const isMainTaxon = (taxon) => taxon.level === 1;
export const isLeafTaxon = (taxon) => (taxon.right - taxon.left) === 1;
export const findMenuTaxon = (taxon) => taxon.level <= 1 ? taxon : taxon.parents.find(isMainTaxon);
export const findProductMenuTaxon = (product) => [product.mainTaxon, ...product.mainTaxonParents].find(isMainTaxon);


export const taxonNestedSet = NestedSet({left: 'left', right: 'right'});



// WEBPACK FOOTER //
// ./utils/taxons.js